import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { editProfileClick } from './actions';
// import MaskedInput from 'react-maskedinput';
import { connect } from 'react-redux';
import {translate} from "react-i18next";

@translate(['modal'], {wait:true})
class ContactsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: this.props.profile.email || '',
      firstName: this.props.profile.firstName || '',
      lastName: this.props.profile.lastName || '',
      middleName: this.props.profile.middleName || '',
    };
  }

  render() {
    const {t} = this.props;

    return (
      <div id="account__tab-сontacts" className="popup__tab active">
        <form className="popupForm grayPopupForm popupForm-short" action="#">
          {/* <div className="popup__settings-row">
            <div className="popup__settings__title popup__settings__title-long">Номер телефона ЛОГИНА</div>
            <div className="popup__settings__holder">
              <div className="row">
                <div className="wrap">
                  <MaskedInput className="inputText inputTel size14" type="text" mask="+1 111 111 11 11"/>
                  <a className="btn-save" href="">Получить код</a>
                </div>
              </div>
              <div className="row">
                <div className="wrap">
                  <input className="inputText size14" type="text" value="" placeholder="Код подтвержения" />
                  <a className="btn-save" href="">Подтвердить</a>
                </div>
              </div>
            </div>
          </div>*/}
          <div className="popup__settings-row">
            <div className="popup__settings__title popup__settings__title-long">{t('modal:contacts__header')}</div>
            <div className="popup__settings__holder">
              <div className="row">
                <label className="popupForm__label">{t('modal:contacts__email')}</label>
                <div className="wrap">
                  <input className="inputText size14" type="text" defaultValue={this.state.email} onChange={(e) => {
                    this.setState({
                      email: e.target.value,
                    });
                  }} />
                </div>
              </div>
              <div className="row">
                <label className="popupForm__label">{t('modal:contacts__last-name')}</label>
                <div className="wrap">
                  <input className="inputText size14" type="text" defaultValue={this.state.lastName} onChange={(e) => {
                    this.setState({
                      lastName: e.target.value,
                    });
                  }} />
                </div>
              </div>
              <div className="row">
                <label className="popupForm__label">{t('modal:contacts__first-name')}</label>
                <div className="wrap">
                  <input className="inputText size14" type="text" defaultValue={this.state.firstName} onChange={(e) => {
                    this.setState({
                      firstName: e.target.value,
                    });
                  }} />
                </div>
              </div>
              <div className="row">
                <label className="popupForm__label">{t('modal:contacts__middle-name')}</label>
                <div className="wrap">
                  <input className="inputText size14" type="text" defaultValue={this.state.middleName} onChange={(e) => {
                    this.setState({
                      middleName: e.target.value,
                    });
                  }} />
                </div>
              </div>
              {/* <div className="row">
                <label className="popupForm__label">Номер телефона</label>
                <div className="wrap">
                  <input className="inputText inputTel size14" type="text" value="+7 999 333 4455" />
                </div>
              </div>
              <div className="row">
                <label className="popupForm__label">Номер телефона</label>
                <div className="wrap">
                  <input className="inputText inputTel size14" type="text" value="+7 222 999 3221" />
                  <a href="" className="removeBtn"></a>
                </div>
              </div>
              <div className="row"><a className="addBtn" href="">+ Добавить еще номер</a></div>*/}
            </div>
          </div>
          <div className="row"><button type="button" onClick={() => this.props.handleSaveClick({email: this.state.email})} className="btn">{t('modal:contacts__save')}</button></div>
        </form>
      </div>
    );
  }
}

ContactsTab.propTypes = {
  profile: PropTypes.object,
  handleSaveClick: PropTypes.func,
};

export default connect(
  (state) => {
    return {
      profile: state.settings.profile,
    };
  },
  (dispatch) => {
    return {
      handleSaveClick(profile) {
        return dispatch(editProfileClick({profile}));
      },
    };
  }
)(ContactsTab);



// WEBPACK FOOTER //
// ./src/components/Modal/SettingsModal/ProfileSettings/ContactsTab.js